import { WysiwygBase64Sanitizer } from './wysiwyg-base64-sanitizer';

export class QuillUtils {
  static attachImageBlocking(
    quillInstance: any,
    blockImages: boolean,
    onValueChange?: (newValue: string) => void): void {
    if (!quillInstance || !blockImages) return;

    const editorElement = quillInstance.root;

    quillInstance.on('text-change', () => {
      const editorRoot = quillInstance.root;
      const allImages = editorRoot.querySelectorAll('img');
      let contentChanged = false;

      if (allImages.length > 0) {
        allImages.forEach((img: HTMLImageElement) => img.remove());
        contentChanged = true;
      }

      const currentContent = editorRoot.innerHTML;
      const sanitizedContent = WysiwygBase64Sanitizer.removeBase64Images(currentContent);

      if (sanitizedContent !== currentContent || contentChanged) {
        editorRoot.innerHTML = sanitizedContent;
        if (onValueChange) {
          onValueChange(sanitizedContent);
        }
      }
    });

    editorElement.addEventListener('drop', (e: DragEvent) => {
      if (!e?.dataTransfer) return;
      for (const item of Array.from(e.dataTransfer.items || [])) {
        if (item.kind === 'file' && item.type.startsWith('image/')) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      }
    });

    const toolbar = quillInstance.getModule('toolbar');
    if (toolbar && toolbar.container) {
      const imageButtons = toolbar.container.querySelectorAll('.ql-image');
      imageButtons.forEach((button: HTMLElement) => {
        button.style.display = 'none';
      });
    }
  }
}
